module.exports = __webpack_public_path__ + "static/media/analytics-mobile.db1615d0.svg";